export default [
  {
    question: "I need help using the app",
    answer:
      "Refer to the tutorial video page in the app to learn how to use the features. If you cannot find what you are looking for, use the contact us page in the app for assistance. ",
  },
  {
    question: "How do I know what program to use?",
    answer:
      "You can use our advanced filter system in the app to help find the perfect program for you. You can also reach out in our community for guidance. See the community tab under the profile screen to gain access.",
  },
  {
    question: "What does “A1, A2” or “B1, B2, B3” mean in the program?",
    answer: `This represents a superset or circuit. This protocol indicates that you should perform each exercise back to back without rest.
    
    Example: complete set #1 of A1, then move directly into set #1 of A2, then rest. When you are ready begin set #2 of A1, then move directly into set #2 of A2, then rest. Repeat this until all sets of each exercise are completed. `,
  },
  {
    question: "What should I do when I complete a program?",
    answer:
      "First ask yourself if you made progress. If yes, you can either repeat that program again or try something more difficult from our library. You can always reach out in our community for help on selecting the right program.",
  },
  {
    question: "Can I repeat a program from the library?",
    answer:
      "Yes! If you have made progress on a program, there is nothing wrong with repeating it again. If you ever complete a program and have not made progress, you should try a different program from our library. You can always reach out in our community for help on selecting the right program.",
  },
  {
    question: "How do I know if I am making progress with the programs?",
    answer:
      "Depending on what type of program you are using, the goals can be different. If it is a strength training program, use the estimated 1 rep max feature built within the app to monitor if you are getting stronger over time. If it’s a muscle-building program, use progress photos (front, side, back) to measure your transformation over time.",
  },
  {
    question: "I injured myself doing an exercise. What should I do?",
    answer:
      "If you have injured yourself please consult a doctor or therapist. It is okay to skip an exercise or a workout until you are properly recovered.",
  },
  {
    question:
      "I want to use one of the programs for a competition peak. How do I time everything right in my calendar?",
    answer:
      "All programs will indicate how many weeks in length they are. I suggest working backward from a calendar to find the start date that would bring you to the week of the competition. When adding the program to your calendar, select this as the start date. You can also use the web-app (app.mystrengthbook.com/login) to use the month view of your calendar to move and adjust workouts.",
  },
  {
    question:
      "What if I choose a program and partway through I realize I don’t like it?",
    answer:
      "No problem. You can remove that program from your calendar in the app and add a new one. Your subscription includes unlimited access and the app is entirely self-serve.",
  },
  {
    question:
      "What happens if I need help with technique or understanding the programs? Is there someone I can ask for help?",
    answer:
      "We have an exclusive community where our subscribers can share progress, ask questions and get help. See the community tab under the profile screen.",
  },
  {
    question: "What equipment do I need to use the programs?",
    answer:
      "Each program is different. Assume you need access to full gym equipment unless otherwise noted in the program tags or description.",
  },
  {
    question: "Can I cancel at any time?",
    answer:
      "Yes. If you decide this is not the right product for you to reach your goals, you can cancel at any time within the app and you will no longer be charged. ",
  },
];
